import { lmsClient } from "api";

const paymentApprovalService = {};

paymentApprovalService.getPendingApprovals = function (data) {
  const params = new URLSearchParams();
  if (data?.bankAccountId) params.append("bankAccountId", data.bankAccountId);
  if (data?.postingDate) params.append("postingDate", new Date(data.postingDate).toISOString());
  if (data?.valueDate) params.append("valueDate", new Date(data.valueDate).toISOString());
  params.append("processId", "PAYMENTRCV");
  params.append("status", "N");
  if (data?.pageIndex) params.append("pageIndex", data.pageIndex);
  if (data?.pageSize) params.append("pageSize", data.pageSize);

  return lmsClient({
    url: `/lm_bank_transaction/paging?${params.toString()}`,
    method: "get",
  });
};

paymentApprovalService.approvePayments = function (items) {
  return lmsClient({
    url: "/lms/payment/approval/approve",
    method: "put",
    data: { items },
  });
};

paymentApprovalService.rejectPayments = function (items) {
  return lmsClient({
    url: "/lms/payment/approval/reject",
    method: "put",
    data: { items },
  });
};

export default paymentApprovalService;
